import {
  disableBodyScroll,
  enableBodyScroll
} from "./chunk.WDF6H473.js";
import {
  JbOverlay
} from "./chunk.5C7B4R5Q.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Animatable
} from "./chunk.VRR2P3PQ.js";
import {
  recenterNavItems
} from "./chunk.WXNWU2SV.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-media-overlay/jb-media-overlay.scss?inline
var jb_media_overlay_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  background-color: #fff;
  display: block;
  min-height: 100%;
}

.media-overlay {
  display: block !important;
  opacity: 0;
}
@media (min-width: 960px) {
  .media-overlay {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 2 * var(--row-small-margin, 6.68%));
  }
}
@media (min-width: 960px) and (min-width: 600px) and (max-width: 959px) {
  .media-overlay {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 960px) and (min-width: 1437px) {
  .media-overlay {
    max-width: var(--row-max-width, 1436px);
  }
  .media-overlay:not(.filtered-list) {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) and (min-width: 960px) and (max-width: 1436px) {
  .media-overlay {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}`;

// src/components/jb-media-overlay/jb-media-overlay.ts
var JbMediaOverlay = class extends Initiable(Animatable(h)) {
  constructor() {
    super(...arguments);
    this.open = false;
    this._mediaOverlay = {
      content: null,
      overlay: null,
      innerContent: null,
      OVERLAY_SELECTOR: ".overlay-template",
      OVERLAY_CONTENT_SELECTOR: ".media-overlay",
      OVERLAY_INNER_CONTENT_SELECTOR: ".media-overlay__content",
      MEDIA_TEMPLATE_SELECTOR: "#media-overlay__media-template",
      DESCRIPTION_TEMPLATE_SELECTOR: "#media-overlay__description-template"
    };
  }
  firstUpdated() {
    this._init();
    if (this.url) {
      this._fetchDataFromApi(this.url);
    } else if (this.overlayContent) {
      this._generateMediaHTML(this.overlayContent);
      this._generateDescriptionHTML(this.overlayContent);
    }
    this.dispatchEvent(
      new CustomEvent("jb-stackable:register-outro-callback", {
        bubbles: true,
        composed: true,
        detail: {
          callback: async () => {
            window.history.replaceState("", "", window.location.pathname);
          }
        }
      })
    );
    this.addEventListener("jb-reveal:contentRevealed", () => {
      const video = this.shadowRoot.querySelector("jb-video");
      if (!video) return;
      video._plyr.play();
      video._plyr.on("ready", () => {
        video._plyr.play();
      });
    });
    document.addEventListener("jb-overlay:close", () => {
      const video = this.shadowRoot.querySelector("jb-video");
      if (!video) return;
      video._plyr.pause();
    });
  }
  _dom() {
    this._mediaOverlay.content = this.renderRoot.querySelector(
      this._mediaOverlay.OVERLAY_CONTENT_SELECTOR
    );
    if (this._mediaOverlay.content) {
      this._mediaOverlay.innerContent = this._mediaOverlay.content.querySelector(
        this._mediaOverlay.OVERLAY_INNER_CONTENT_SELECTOR
      );
      this._mediaOverlay.overlay = this._mediaOverlay.content.closest(
        this._mediaOverlay.OVERLAY_SELECTOR
      );
    }
  }
  _fetchDataFromApi(url) {
    fetch(url).then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not OK");
      }
      return response.json();
    }).then((data) => {
      this._populateMediaOverlay(data);
    });
  }
  _generateDescriptionHTML(data) {
    const descriptionTemplate = this._mediaOverlay.overlay.querySelector(
      this._mediaOverlay.DESCRIPTION_TEMPLATE_SELECTOR
    );
    const descriptionClone = descriptionTemplate.content.cloneNode(true);
    const description = descriptionClone.querySelector(".media-overlay__description");
    description.innerHTML = data.description;
    this._mediaOverlay.innerContent.appendChild(descriptionClone);
  }
  _generateMediaHTML(data) {
    const videoTemplate = this._mediaOverlay.overlay.querySelector(this._mediaOverlay.MEDIA_TEMPLATE_SELECTOR);
    const videoClone = videoTemplate?.content.cloneNode(true);
    const media = videoClone.querySelector(".media-overlay__media");
    media.innerHTML = data.media;
    this._mediaOverlay.innerContent.appendChild(videoClone);
  }
  _init() {
    this._dom();
  }
  _populateMediaOverlay(data) {
    this._generateMediaHTML(data);
    this._generateDescriptionHTML(data);
  }
  render() {
    return ke`
      <section class="overlay-template">
        <div class="media-overlay">
          <div class="media-overlay__content"></div>
        </div>

        <template id="media-overlay__media-template">
          <div class="media-overlay__media"></div>
        </template>

        <template id="media-overlay__description-template">
          <div class="media-overlay__description"></div>
        </template>
      </section>
    `;
  }
};
JbMediaOverlay.styles = r(jb_media_overlay_default);
__decorateClass([
  n({ type: Boolean })
], JbMediaOverlay.prototype, "open", 2);
__decorateClass([
  n()
], JbMediaOverlay.prototype, "overlayContent", 2);
__decorateClass([
  n()
], JbMediaOverlay.prototype, "url", 2);
JbMediaOverlay = __decorateClass([
  customElement("jb-media-overlay")
], JbMediaOverlay);
bindEvents();

// src/components/jb-media-overlay/jb-media-overlay-controller.ts
var mediaLinksRegister = {};
var JbMediaOverlayController = class {
  constructor() {
    this.mediaOverlay = void 0;
    this.overlay = void 0;
  }
  async close() {
    if (this.mediaOverlay) {
      await this.mediaOverlay.hide();
      enableBodyScroll(this.mediaOverlay);
      recenterNavItems();
    }
    if (this.overlay) {
      this.overlay.unstack();
    }
    this.overlay = void 0;
  }
  handleHashChange() {
    const hash = window.location.hash.substring(1);
    if (hash === "" || !hash.includes("overlayMedia")) {
      this.close();
      return;
    }
    const mediaId = hash.split("=")[1];
    const endpoint = document.body.dataset.mediaOverlayEndpoint;
    if (!endpoint) {
      this.close();
      return;
    }
    mediaLinksRegister[mediaId] = endpoint.replace(":mediaId", mediaId);
    const url = mediaLinksRegister[mediaId];
    this.mediaOverlay = new JbMediaOverlay().init({
      props: { url }
    });
    this.overlay = new JbOverlay().init({
      props: { color: "white", hasLogo: false, hasCloseIcon: true, newAnimation: true },
      childNodes: [this.mediaOverlay]
    });
    if (this.overlay) {
      this.overlay.stack();
      customElements.whenDefined("jb-media-overlay").then(async () => {
        setTimeout(() => {
          this.mediaOverlay.contentChildren = Array.from(
            this.mediaOverlay.shadowRoot.querySelectorAll(".media-overlay")
          );
        }, 0);
        disableBodyScroll(this.mediaOverlay, { allowTouchMove: () => true });
        recenterNavItems();
        await this.mediaOverlay.reveal();
      });
    }
  }
  open(event) {
    const customEvent = event;
    if (customEvent.detail.id || customEvent.detail.media) {
      customEvent.stopPropagation();
      customEvent.detail.clickEvent.preventDefault();
      customEvent.detail.clickEvent.stopPropagation();
      const baseUrl = window.location.href.split("#")[0];
      let newUrl = "";
      if (customEvent.detail.id) {
        newUrl = baseUrl + "#overlayMedia=" + customEvent.detail.id;
        window.open(newUrl, "_self");
      } else {
        const overlayContent = {
          media: customEvent.detail.media,
          description: customEvent.detail.description
        };
        this.mediaOverlay = new JbMediaOverlay().init({
          props: { overlayContent }
        });
        this.overlay = new JbOverlay().init({
          props: { color: "white", hasLogo: false, hasCloseIcon: true, newAnimation: true },
          childNodes: [this.mediaOverlay]
        });
        if (this.overlay) {
          this.overlay.stack();
          customElements.whenDefined("jb-media-overlay").then(async () => {
            setTimeout(() => {
              this.mediaOverlay.contentChildren = Array.from(
                this.mediaOverlay.shadowRoot.querySelectorAll(".media-overlay")
              );
            }, 0);
            disableBodyScroll(this.mediaOverlay, { allowTouchMove: () => true });
            recenterNavItems();
            await this.mediaOverlay.reveal();
          });
        }
      }
    }
  }
};
var controller = new JbMediaOverlayController();
function bindEvents() {
  document.addEventListener("jb-overlay:close", () => {
    controller.close();
  });
  document.body.addEventListener("jb-link:initialized", (event) => {
    const customEvent = event;
    if (!customEvent.detail.id) {
      return;
    }
    mediaLinksRegister[customEvent.detail.id] = customEvent.detail.url;
  });
  document.addEventListener("jb-link:clicked", (event) => {
    controller.open(event);
  });
  window.onhashchange = () => {
    controller.handleHashChange();
  };
  window.setTimeout(() => {
    controller.handleHashChange();
  }, 0);
}

export {
  bindEvents,
  JbMediaOverlay
};
